import { useQuery } from "@tanstack/react-query";
import { getEmployee } from "../../api/apiEmployees";
import i18next from "i18next";

export function useGetEmployee(id) {
    const { isLoading, data: employee, error } = useQuery({
        queryKey: ["employees", id, i18next.language],
        queryFn: () => getEmployee(id),
        enabled: !!id,
        retry: false,
    });
    return { isLoading, error, employee };
}
